import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getPromoBrief = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/productivity-host/briefs/promotions' });

  return data;
};

export default getPromoBrief;
